import { motion, useScroll } from "framer-motion";
import { B2C_ENABLED } from "../config/features";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import ValueSection from "../components/landing/ValueSection";
import CourseCatalogSection from "../components/landing/CourseCatalogSection";
import DiplomadoSection from "../components/landing/DiplomadoSection";
import BundleSection from "../components/landing/BundleSection";
import HowItWorksSection from "../components/landing/HowItWorksSection";
import AudienceSection from "../components/landing/AudienceSection";
import TrackRecordSection from "../components/landing/TrackRecordSection";
import EventsGallerySection from "../components/landing/EventsGallerySection";
import FAQSection from "../components/landing/FAQSection";
import TestimonialsSection from "../components/landing/TestimonialsSection";
import BonusSection from "../components/landing/BonusSection";
import OfferSection from "../components/landing/OfferSection";
import AboutSection from "../components/landing/AboutSection";
import PCMASection from "../components/landing/PCMASection";
import FooterSection from "../components/landing/FooterSection";

const LandingPage = () => {
  const { scrollYProgress } = useScroll();

  return (
    <div data-testid="landing-page" className="min-h-screen">
      {/* Progress Bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-[#F59E0B] origin-left z-[60]"
        style={{ scaleX: scrollYProgress }}
      />

      <Header />

      <main>
        <HeroSection />
        <ValueSection />
        <CourseCatalogSection />
        <DiplomadoSection />
        {B2C_ENABLED && <BundleSection />}
        <HowItWorksSection />
        <AudienceSection />
        <TrackRecordSection />
        <EventsGallerySection />
        <TestimonialsSection />
        <BonusSection />
        {B2C_ENABLED && <OfferSection />}
        <FAQSection />
        <AboutSection />
        <PCMASection />
        <FooterSection />
      </main>
    </div>
  );
};

export default LandingPage;
